import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert02Icon, AlertCircleIcon, CheckmarkCircle01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './VerificationCard.module.scss';

export const Statuses = {
  Error: 'error',
  Success: 'success',
  Warn: 'warn',
};

export const VerificationCard = ({ children }) => (
  <div
    className={cn(
      styles.root,
      'p-4 border border-neutral-4 rounded-3xl shadow-sm bg-neutral-1 flex flex-col gap-2 min-w-0',
    )}>
    {children}
  </div>
);

const Header = ({ icon, fa = false, hugeicons = false, children }) => (
  <div className="flex items-center gap-2 text-sm text-neutral-6 font-medium uppercase tracking-wide">
    {fa ? (
      <FontAwesomeIcon icon={['fab', icon]} size="16" />
    ) : hugeicons ? (
      <HugeiconsIcon icon={icon} size="16" />
    ) : (
      <FeatherIcon icon={icon} size="16" />
    )}
    {children}
  </div>
);

const Link = ({ href, children }) => (
  <OverlayTrigger
    trigger={children ? ['hover', 'focus'] : 'none'}
    placement="top"
    overlay={<Tooltip>{children}</Tooltip>}>
    <a
      href={href}
      className="block min-w-0 truncate text-xl text-primary-4 hover:text-primary-5 transition-colors duration-300 hover:underline font-medium">
      {children}
    </a>
  </OverlayTrigger>
);

const Value = ({ children }) => (
  <div className="text-2xl text-neutral-7 font-medium break-words">{children}</div>
);

const AlertMessage = ({ status, children }) => (
  <div
    className={cn('flex items-start gap-2 text-lg', {
      [styles.alertMessageError]: status === Statuses.Error,
      [styles.alertMessageSuccess]: status === Statuses.Success,
      [styles.alertMessageWarn]: status === Statuses.Warn,
    })}>
    {status === Statuses.Warn && <HugeiconsIcon icon={Alert02Icon} size="16" />}
    {status === Statuses.Error && <HugeiconsIcon icon={AlertCircleIcon} size="16" />}
    {status === Statuses.Success && <HugeiconsIcon icon={CheckmarkCircle01Icon} size="16" />}
    {children}
  </div>
);

VerificationCard.Header = Header;
VerificationCard.Link = Link;
VerificationCard.AlertMessage = AlertMessage;
VerificationCard.Value = Value;
